export const data = {
    labels: ['장비', '물품매매'],
    datasets: [{
        label: '비중',
        backgroundColor: ['#FFA0B5', '#90C5F3']
    }],
};

export const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        datalabels: {
            formatter: function(value, context) {
                let total = 0;
                context.chart.data.datasets[0].data.map(i=>{
                    total += i
                })

                return `${(value / 100000000).toFixed(2) + " 억원"} (${(value/total*100).toFixed(1) }%)`;
            }
        }
    },
    onHover: (event, chartElement) => {
        event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    }
}
